export default "__VITE_ASSET__BQqukcXi__"